import { Button, Modal } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

interface ICapacityErrorModalProps {
  opened: boolean;
  setUserClosedModal: (value: React.SetStateAction<boolean>) => void;
  close: () => void;
}

function CapacityErrorModal({
  close,
  opened,
  setUserClosedModal,
}: ICapacityErrorModalProps) {
  const navigate = useNavigate();
  const onModalClose = () => {
    setUserClosedModal(true);
    close();
  };

  function onClick() {
    navigate('/edit-capacity');
  }

  return (
    <Modal opened={opened} onClose={onModalClose} centered>
      <div className="flex flex-col gap-8">
        <p className="text-xl font-semibold">No Capacity for Selected Date</p>
        <p>
          There is currently no capacity for the date selected. Please set
          capacity or choose a different date.
        </p>
        <Button
          className="font-semibold text-white border-2 bg-primary-500 hover:bg-primary-600 hover:border-primary-600 border-primary-500 w-fit"
          onClick={() => onClick()}
        >
          Set Capacity
        </Button>
      </div>
    </Modal>
  );
}

export default CapacityErrorModal;
